// extracted by mini-css-extract-plugin
export default {"card":"SendCardModal_card__QKqSS"};